import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import DisponibilidadActivaGrid from './DisponibilidadActivaGrid.jsx';

const DisponibilidadActiva = ({ match }) => (
  <div className="content-wrapper">
    <div className="content-header row">
      <div className="content-header-left col-md-6 col-12 mb-2">
        <h3 className="content-header-title">
          <FormattedMessage
            id="disponibilidadActiva.titulo"
            defaultMessage="Disponibilidad Activa"
          />
        </h3>
      </div>
    </div>
    <div className="content-body">
      <Switch>
        <Route exact path={`${match.url}`} component={DisponibilidadActivaGrid} />
      </Switch>
    </div>
  </div>
);

export default withRouter(DisponibilidadActiva);
